import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css'; // Import Bootstrap CSS globally
import './i18n';
import ReactGA from 'react-ga4';

if (process.env.REACT_APP_GA_MEASUREMENT_ID) {
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('GA initialization with Measurement ID:', process.env.REACT_APP_GA_MEASUREMENT_ID);
  ReactGA.initialize(process.env.REACT_APP_GA_MEASUREMENT_ID, {
    gtagOptions: { debug_mode: process.env.NODE_ENV === 'development' },
  });
}


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
